const getFooterData = state => {
  if (!state.FooterLinkReducer.footerLink) {
    return [];
  }
  return state.FooterLinkReducer.footerLink;
};

const getFooterLoading = state => {
  return state.FooterLinkReducer.loading.footerLink;
};

const getFooterError = state => {
  return state.FooterLinkReducer.error.footerLink;
};

const isLoading = state => {
  return getFooterLoading(state);
};

export const FooterSelector = {
  getFooterData,
  getFooterLoading,
  getFooterError,
  isLoading,
};
